import axios from 'axios';

export interface DayStats {
  date: string;
  total: number;
  avg_score_pct: number;
  high: number;
  mid: number;
  low: number;
}

export interface FieldAccuracy {
  field: string;
  correct_pct: number;
  total: number;
}

export interface ScanTypeSummary {
  total: number;
  avg_score_pct: number;
  high: number;
  mid: number;
  low: number;
}

export interface ExtractionAccuracyData {
  days: DayStats[];
  summary: {
    total_receipts: number;
    overall_avg_score_pct: number;
  };
  field_accuracy: FieldAccuracy[];
  scan_type_breakdown?: {
    proxy: ScanTypeSummary;
    corp_action: ScanTypeSummary;
    regulatory: ScanTypeSummary;
    issuer: ScanTypeSummary;
  };
}

export async function getExtractionAccuracy(): Promise<ExtractionAccuracyData> {
  const { data } = await axios.get<ExtractionAccuracyData>('/api/v1/analytics/extraction-accuracy');
  return data;
}
